$(document).ready(function () {
  const $fileInput = $('#avatar');
  const $imgPreview = $('.show-avatar');

  if ($fileInput.length === 0 || $imgPreview.length === 0) return;

  $fileInput.on('change', function () {
    const file = this.files && this.files[0];
    if (!file) return;

    // Kiểm tra kiểu file (phòng trường hợp user đổi accept trên devtools)
    if (!/^image\/(png|jpe?g|gif|webp)$/i.test(file.type)) {
      alert('Vui lòng chọn file hình (PNG, JPG, JPEG, GIF, WEBP).');
      this.value = '';
      return;
    }

    // Giải phóng object URL cũ nếu có (tránh leak)
    const oldUrl = $imgPreview.data('objectURL');
    if (oldUrl) {
      URL.revokeObjectURL(oldUrl);
    }

    const objectURL = URL.createObjectURL(file);
    $imgPreview.attr('src', objectURL);
    $imgPreview.data('objectURL', objectURL);

    // (Tuỳ chọn) thêm class đã có ảnh
    $imgPreview.addClass('has-image');
  });
});

// Initialize Swiper
window.addEventListener("load", function () {
  var swiper = new Swiper(".saveSwiper", {
    navigation: {
      nextEl: ".gr_cards .swiper-button-next",
      prevEl: ".gr_cards .swiper-button-prev",
    },
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
  });
});